import { useRef, useState } from "react";
import { Layers } from "@mui/icons-material";
import { Fab, Popper, styled, Tooltip } from "@mui/material";
import { ControlOptions } from "leaflet";
import { useTranslation } from "react-i18next";

import { MapControlBase } from "../../utils/MapControlBase";
import { SelectBaseLayerWrapper } from "./SelectBaseLayerWrapper";

interface Props extends ControlOptions {}

export function SelectBaseLayersControl(props: Props) {
  const { ...controlProps } = props;
  const { t } = useTranslation();
  const anchorEl = useRef<HTMLButtonElement | null>(null);
  const [active, setActive] = useState(false);
  return (
    <MapControlBase {...controlProps}>
      <Tooltip title={t("label.backgroundAndExtraLayers")} placement="left">
        <Fab
          size="small"
          variant="circular"
          ref={anchorEl}
          onClick={() => setActive((prev) => !prev)}
          color={active ? "primary" : "default"}
        >
          <Layers />
        </Fab>
      </Tooltip>

      <StyledPopper
        open={active}
        anchorEl={anchorEl.current}
        placement="left-end"
      >
        <SelectBaseLayerWrapper />
      </StyledPopper>
    </MapControlBase>
  );
}

const StyledPopper = styled(Popper)`
  z-index: 9999;
`;
